import * as UI from "@iyk/ui"
import * as React from "react"

import { Assets } from "../../../packages/assets.ts"
import { StarbaseIcon } from "../../../packages/starbase-icon.tsx"
import { VerifiedProfileIcon } from "./icons.tsx"
import { Link, Routes } from "./link.tsx"

export const UserProfileCard = (props: UserProfileCard.Props) => {
  const hasAtLeastOneProof = props.totalCheckIns > 0

  return (
    <Link
      to={Routes.collection(props.userId)}
      className="overflow-hidden relative flex flex-col p-3 pt-7 rounded  bshadow bshadow-grayA-4 h-[210px] backdrop-blur-sm"
    >
      <img src={Assets.images.userCardStarBackground} className="absolute top-0 left-0 w-full" />
      <div className="grow flex flex-col justify-center">
        {hasAtLeastOneProof ? (
          <div className="flex items-center gap-3">
            {hasAtLeastOneProof && <VerifiedProfileIcon className="size-5" />}
            <div className={classForUserLabel}>
              {props.variant === "profile" ? (
                <React.Fragment>
                  <span>{props.username}</span>
                  <br />
                  <span>Since {props.since}</span>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <span className="text-gray-11">Owner:</span>
                  <br />
                  <span>{props.username}</span>
                </React.Fragment>
              )}
            </div>
          </div>
        ) : (
          <span className={classForUserLabel}>{props.username}</span>
        )}
      </div>

      <div className="flex justify-between items-center">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <StarbaseIcon className="size-5" />
            <span className="text-xs">{props.totalCheckIns}</span>
          </div>
        </div>
        <span className={UI.classForButton({ size: "sm", kind: "shaded" })}>
          <UI.Icon.Eye /> View {props.variant === "profile" && "my"} collection
        </span>
      </div>
    </Link>
  )
}

const classForUserLabel = UI.cx(
  "uppercase text-[11px] leading-[16px] tracking-upper font-departure-mono",
)

namespace UserProfileCard {
  export type Props = {
    userId: string
    username: string
    since: string
    totalCheckIns: number
    variant: "owner" | "profile"
  }
}
